module.exports = __webpack_public_path__ + "img/key.c1d20ca3.svg";